import { COLOR_TYPES, gradientColorTypes } from "routes/qrcodes/qr_design/DotSettingsSection";
import { defaultQrDesignValues as DEFAULT_DATA } from "../models/QrDesignFormDefaultValues";

export const getColorProperties = (dotSettings) => {
	const DEFAULT_COLOR = "#000000";
	const gradientProperties = {
		type: gradientColorTypes[0].value,
		rotation: 0,
		colorStops: [
			{ offset: 0, color: DEFAULT_COLOR },
			{ offset: 1, color: DEFAULT_COLOR },
		],
		...dotSettings.gradient,
	};
	const solidProperties = {
		color: COLOR_TYPES.GRADIENT in dotSettings ? DEFAULT_COLOR : dotSettings.color,
	};
	return {
		solid: solidProperties,
		gradient: gradientProperties,
		dotsColorType: COLOR_TYPES.GRADIENT in dotSettings ? COLOR_TYPES.GRADIENT : COLOR_TYPES.SOLID,
	};
};

export const translateFromDesignDataIntoQrDesignFormData = (data) => {
	if (!data || !data.details) {return DEFAULT_DATA;}
	return {
		...data,
		logo: {
			filename: data.details.imageName,
			base64: data.details.image,
		},
		...getColorProperties(data.details.dotsOptions),
	};
};
